// --- components/WhyChooseSamsan.tsx ---
// This component highlights the reasons to choose Samsan Inc.
'use client';
export const WhyChooseSamsan: React.FC = () => {
  const reasons = [
    "Trusted by contractors and engineers across multiple industries",
    "Rapid response supply chain",
    "Competitive pricing on global brands",
    "Technical sourcing and after-sales support",
  ];

  return (
    <section className="bg-white text-black py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 text-start max-w-4xl">
        <h2 className="text-5xl sm:text-5xl lg:text-6xl font-extrabold mb-8 leading-tight">
          Why Choose Samsan Inc.?
        </h2>
        <div className="space-y-6 md:space-y-8">
          {reasons.map((reason, index) => (
            <div key={index} className="flex items-start justify-start text-left mx-auto max-w-2xl">
              <svg
                className="w-8 h-8 text-yellow-600 flex-shrink-0 mr-3 mt-1"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
              <p className="text-lg sm:text-xl text-gray-800 font-medium">
                {reason}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSamsan;